/**
 * Created by Shikha Gupta on 2021-09-15.
 */
import {GameHelper} from "../../core/utils/GameHelper";
import {TweenLite} from "gsap";
import {IBetLinesConfig, OktoberfestGameConfig} from "../OktoberfestGameConfig";
import {Oktoberfest} from "../Oktoberfest";

export class StaticBetLineNumber extends PIXI.Sprite {

    private _config: IBetLinesConfig;
    private _positions: number[];
    private _isPlayingWin: boolean;
    private _normalText: PIXI.Text;
    private _normalTextStyle: PIXI.TextStyle;
    private _normalTextAlphaTween: TweenLite;
    private _normalTextScaleTween: TweenLite;
    private _winText: PIXI.Text;
    private _winTextStyle: PIXI.TextStyle;
    private _winTextAlphaTween: TweenLite;
    private _winTextScaleTween: TweenLite;

    constructor(positions: number[], index: number, resourcesLoaded: boolean) {
        super();

        this._index = index;
        this._positions = positions.concat();

        this.init();

    }

    private _index: number;

    get index(): number {
        return this._index;
    }

    public onShowWinBetLine(index: number): void {
        if (index !== this._index) {
            return;
        }

        this._isPlayingWin = true;

        this.killAllTweens();
        this._normalTextAlphaTween = TweenLite.to(this._normalText, 0.1, {alpha: 0});
        this._winTextAlphaTween = TweenLite.to(this._winText, 0.1, {alpha: 1});
        this._normalTextScaleTween = TweenLite.to(this._normalText.scale, 0.17, {
            x: this._config.numberWinScale,
            y: this._config.numberWinScale
        });
        this._winTextScaleTween = TweenLite.to(this._winText.scale, 0.17, {
            x: this._config.numberWinScale,
            y: this._config.numberWinScale
        });
    }

    public onHideWinBetLine(index: number): void {
        if (index !== this._index) {
            return;
        }

        this.onHideAllBetLines();
    }

    public onHideAllBetLines(): void {
        this._isPlayingWin = false;

        this.killAllTweens();
        this._normalTextAlphaTween = TweenLite.to(this._normalText, 0.33, {alpha: 1});
        this._winTextAlphaTween = TweenLite.to(this._winText, 0.33, {alpha: 0});
        this._normalTextScaleTween = TweenLite.to(this._normalText.scale, 0.33, {x: 1, y: 1});
        this._winTextScaleTween = TweenLite.to(this._winText.scale, 0.33, {x: 1, y: 1});
    }

    public setEnabled(value: boolean): void {
        this.interactive = value;
        this.onHideAllBetLines();
    }

    protected initAnimations(): void {
        this.addChild(this.createBackground());

        this._normalText = new PIXI.Text(this.index.toString(), this._normalTextStyle);
        this._normalText.anchor.set(0.5, 0.5);
        this.addChild(this._normalText);

        this._winText = new PIXI.Text(this.index.toString(), this._winTextStyle);
        this._winText.anchor.set(0.5, 0.5);
        this._winText.alpha = 0;
        this.addChild(this._winText);

        this.x = this._positions[0];
        // the numberOffsetX is for making a space between the start point of the line and the number.
        if (this._positions[2] === 0) {
            this.x -= this._config.numberOffsetX;
        } else {
            this.x += (this._config.numberOffsetX - 10);
        }
        this.y = this._positions[1];
    }

    protected createBackground(): PIXI.DisplayObject {
        let background: PIXI.Graphics = new PIXI.Graphics();
        background.beginFill(0x000000, 0);
        background.drawRect(0, 0, this._config.numberWidth, this._config.numberHeight);
        background.endFill();
        return background;
    }

    private init(): void {
        this._isPlayingWin = false;
        this._config = OktoberfestGameConfig.BET_LINES;
        this._normalTextStyle = new PIXI.TextStyle(OktoberfestGameConfig.BET_LINE_NUMBERS_NORMAL_STYLE);
        this._winTextStyle = new PIXI.TextStyle(OktoberfestGameConfig.BET_LINE_NUMBERS_WIN_STYLE);
        this.initAnimations();
        this.initButtonMode();
    }

    private initButtonMode(): void {
        this.setEnabled(true);
        this.on('mouseout', this.onMouseOut);
        this.on('mouseover', this.onMouseOver);
    }

    private onMouseOver(): void {
        if (this._isPlayingWin) {
            return;
        }

        if (!GameHelper.isDesktop()) {
            return;
        }

        this.killAllTweens();
        this._normalTextAlphaTween = TweenLite.to(this._normalText, 0.1, {alpha: 0});
        this._winTextAlphaTween = TweenLite.to(this._winText, 0.1, {alpha: 1});
        Oktoberfest.betlines.showStaticBetLine(this.index);
    }

    private onMouseOut(): void {
        if (this._isPlayingWin) {
            return;
        }

        this.killAllTweens();
        this._normalTextAlphaTween = TweenLite.to(this._normalText, 0.1, {alpha: 1});
        this._winTextAlphaTween = TweenLite.to(this._winText, 0.1, {alpha: 0});
        Oktoberfest.betlines.hideStaticBetLine(this.index);
    }

    private killAllTweens(): void {
        if (this._normalTextAlphaTween && this._normalTextAlphaTween.isActive()) {
            this._normalTextAlphaTween.kill();
        }

        if (this._normalTextScaleTween && this._normalTextScaleTween.isActive()) {
            this._normalTextScaleTween.kill();
        }

        if (this._winTextAlphaTween && this._winTextAlphaTween.isActive()) {
            this._winTextAlphaTween.kill();
        }

        if (this._winTextScaleTween && this._winTextScaleTween.isActive()) {
            this._winTextScaleTween.kill();
        }
    }

}

